export default __webpack_public_path__ + "static/media/triangle.fae12799.svg";